import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";

import Gtag from "../../services/gtag";
import { getFieldByPath } from "../../services/utils";
import types from "./types";

export const gaTrackingMiddleware = (store) => (next) => (action) => {
  if (action.type === types.ROUTER_LOCATION_CHANGED) {
    const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`;
    trackPage(nextPage, store.getState());
  }

  if (types[action.type]) {
    trackEvent(types[action.type], store.getState(), action.payload);
  }

  return next(action);
};

function trackPage(page, state) {
  const isMobile = page.includes("stage/mobile");

  if (page.includes("registered") || isMobile) {
    return;
  }

  ReactGA.set({
    page,
    // userId: state.user._id
  });
  ReactGA.pageview(page);
  ReactPixel.pageView();
  Gtag.pageView(page);
}

const trackEvent = (properties, state, payload) => {
  const data = {
    ...properties,
    action: payload && payload.action ? payload.action : properties.action,
    label:
      payload && payload.label
        ? payload.label
        : getFieldByPath(state, properties.eventDataOne),
    value: payload && payload.value ? payload.value : 0,
  };
  ReactGA.event(data); // Track event to google analytics
};
